import React, { useEffect, useState } from 'react'
import Collapse from '../mini/Collapse'
import TextInput from '../form/TextInput'
import CountriesInput from '../form/CountriesInput'
import SelectInput from '../form/SelectInput'
import { MenuItem } from '@mui/material'
import { travelersInfo } from '../../data/flight/travelersInfo'
import { clone } from '../../features/utils/objClone'
import moment from 'moment'
import getSavedTravelers from '../../controllers/Travelers/getSavedTravelers'

import FetchTravelers from '../form/FetchTravelers'

import { getPassengerCategory } from '../../utils/getPassengerCategory'
import NameInput from '../form/NameInput'
import { isCustomerSite } from '../../utils/getsubDomain'
import { SSR } from '../../data/flight/booking/SSR'

export function validateAge(birthDate,type) {
  let age = moment().diff(birthDate,'years')
  age += Math.max(0,(moment().month() - moment(birthDate).month())) / 100
  let valid = false;
  let msg = '';

  const validate = (val) => {valid = val; return val};
  const errorMsg = (val) => {msg = val};
  
  if(type === 'infant')
    validate(age < 2) || errorMsg(`${type}s should be under 3 `);
  else if(type === 'child')
    validate(age < 12) || errorMsg(`${type}s should be between 3 and 12 `);
  else if(type === 'adult')
    validate(age >= 12) || errorMsg(`${type}s should be over 11 `);


  return [valid,msg,age];
}

export default function PrimaryPassenger({data:gotData,label,type,handleReturn,count=0,collapse=false,config:gotConfig,hide}) {

  const [data,setData] = useState(clone(gotData || travelersInfo))
  const [savedTravelers,setSavedTravelers] = useState([]);
  const customer = isCustomerSite();

  const config = {
    collapser: Collapse,
    ...(gotConfig||{})
  }

  useEffect(() => {
    if(!customer)
      loadTravelers();
  },[])

  async function loadTravelers() {
    const res = await getSavedTravelers()
    if(res.return) {
      // console.log(res?.data?.data?.map(obj => ({Objtype: getPassengerCategory(obj?.birthDate),type})))
      setSavedTravelers(res?.data?.data?.filter(obj => type?.toLowerCase() === getPassengerCategory(obj?.birthDate)?.toLowerCase()));
    }
  }

  function convertPassengerType(name) {
    if(name === 'adult')
      return 'ADT'
    else if(name === 'child')
      return 'CNN'
    else if(name === 'infant')
      return 'INF'
    
    return name
  }
  
  useEffect(() => {
    if(gotData)
      setData(gotData)
  },[gotData])
  

  // useEffect(() => {
  //   if(traveler?._id && savedTravelers?.length)
  //     handleTravelerSelect(clone(traveler))
  // },[traveler,savedTravelers])
  
  function handleData(obj,config) {
    // console.log(obj)

    const {saved} = config || {}
    setData(obj)
    let {email,phone,birthDate,expiryDate,...rest} = clone(obj)
    birthDate = moment(birthDate).format('YYYY-MM-DD')
    expiryDate = moment(expiryDate).format('YYYY-MM-DD')
    console.log('data: ',{...rest,birthDate,expiryDate,gotType: type,type: convertPassengerType(type)})
    handleReturn && handleReturn(saved?{...obj,type: convertPassengerType(type)}:{...rest,birthDate,expiryDate,gotType: type,type: convertPassengerType(type)},count)
  }

  const expiredPassport = data?.document?.expiryDate && moment(data?.document?.expiryDate).isBefore(moment(),'day');

  let Collapser = config.collapser;
  // if(typeof config.collapser === "string" )
  //   Collapser = React.createElement(config.collapser)

  function handleTravelerSelect(id) {
    let data = null;
    if(typeof(id) === 'object')
      data = id;

    const {_id:_,account,createdAt,updatedAt,document,...travelerData} = data || savedTravelers?.find(obj => obj?._id === id) || {}

    if(document)
      document.holder = document?.holder === 'true' ? true : false

    if(travelerData)
      handleData({...travelerData,document},{saved:true})

  }
  
  return (
    <div>
      <Collapser label={label || 'Primary Passenger'} show={!collapse}>
        <div className='flex flex-col gap-4'>
          {!customer ? 
            <FetchTravelers from={savedTravelers} shrink={false}
              label='/ Select an existing passenger'
              onChange={(obj) => handleTravelerSelect(obj)}
            />
          :null}
          <div className='flex gap-4 flex-wrap md:flex-nowrap'>
            <NameInput label={'First name'} required placeholder={'e.g John'}
              inputProps={{
                pattern: "[a-zA-Z]+"
              }}
              helperText={'Only alphabets is allowed'}
              value={data.firstName}
              onChange={(value) => handleData({...data,firstName: value})}
            />
            <NameInput label={'Middle name'} placeholder={'e.g Doe'}
              inputProps={{
                pattern: "[a-zA-Z]+"
              }}
              helperText={'Only alphabets is allowed'}
              value={data.middleName}
              onChange={(value) => handleData({...data,middleName: value})}
            />
            <NameInput label={'Surname'} required placeholder={'e.g Ike'}
              inputProps={{
                pattern: "[a-zA-Z]+"
              }}            
              value={data.lastName}
              onChange={(value) => handleData({...data,lastName: value})}
            />
          </div>
          <div className='flex gap-4 flex-wrap md:flex-nowrap'>
            <div className='flex-1'>
              <CountriesInput label={'Nationality'} required
                value={data?.document?.nationality}
                onChange={(val) => handleData({...data,document:{...data.document,nationality: val?.alpha2 || val}})}
              />
            </div>
            <div className='flex-1'>
              <SelectInput label='Gender' required
                value={data.gender}
                onChange={(ev) => handleData({...data,gender: ev.target.value})}
              >
                <MenuItem value='Male'>Male</MenuItem>
                <MenuItem value='Female'>Female</MenuItem>
              </SelectInput>
            </div>
            <div className='flex-1'>
              <TextInput type='date' label={'Date of Birth'} required
                error={data.birthDate && !validateAge(data.birthDate,type)[0]}
                helperText={data.birthDate && <span className='text-red-500'>{validateAge(data.birthDate,type)[1]}</span>}
                value={data.birthDate}
                onChange={(ev) => handleData({...data,birthDate: ev.target.value})}
              />
            </div>
          </div>
          <div className='flex gap-4 flex-wrap md:flex-nowrap'>
            <div className='flex-1'>
              <TextInput label='Passport or ID number' required
                value={data?.document?.number}
                onChange={(ev) => handleData({...data,document:{...data.document,number: ev.target.value}})}
               />
            </div>
            <div className='flex-1'>
              <TextInput type='date' label='Passport or ID Expiration Date' required
                error={expiredPassport}
                helperText={<span className='text-red-500'>{expiredPassport ? 'Expired Passport!':''}</span>}
                value={data?.document?.expiryDate}
                onChange={(ev) => handleData({...data,document: {...data.document,expiryDate: ev.target.value}})}
              />
            </div>
          </div>
          {/* <div className='flex gap-4 flex-wrap md:flex-nowrap'>
            <div className='flex-1'>
              <CountriesInput label={'Issuance Location'}
                value={data?.document?.issuanceLocation}
                onChange={(val) => handleData({...data,document:{...data.document,issuanceLocation: val?.alpha2 || val}})}
              />
            </div>
            <div className='flex-1'>
              <TextInput type='date' label='Issuance Date' 
                value={data.document.issuanceDate}
                onChange={(ev) => handleData({...data,document: {...data.document,issuanceDate: ev.target.value}})}
              />
            </div>
          </div> */}

          {!hide?.includes('additional detail') ? 
            <div className='flex gap-4 flex-col'>
              <h5>Additional details</h5>
              <div className='flex gap-4'>
                <div className='flex-1'>
                  <TextInput label='Frequent flyer number' placeholder='Enter here'
                    value={data?.frequentFlyer}
                    onChange={(ev) => handleData({...data,frequentFlyer: ev?.target?.value})}
                    />
                </div>
                <div className='flex-1'>
                  <SelectInput label='Special assistance' placeholder='Select'
                    value={data?.specialAssistance}
                    onChange={(ev) => handleData({...data,specialAssistance: ev?.target?.value})}
                    >
                    {Object.entries(SSR)?.map(([key,val],i) => (
                      <MenuItem key={i} value={key}>{val}</MenuItem>
                    ))}
                  </SelectInput>
                </div>
              </div>
            </div>
          :null}

          {!hide?.includes('remark') ? 
            <div className='flex gap-4 flex-col'>
              <h5>Remarks</h5>
              <TextInput multiline rows={4} label='' placeholder={'Add any special requirments here'}
                value={data?.generalRemark}
                onChange={(ev) => handleData({...data,generalRemark: ev?.target?.value})}
                />
            </div>
          :null}
        </div>
      </Collapser>
    </div>
  )
}